const ITEMS = [
  "Solid Teakwood",
  "Kiln-Dried Timber",
  "Factory Direct Pricing",
  "Custom Sizes Built To Measure",
  "Mumbai",
  "Navi Mumbai",
  "Thane",
  "Wardrobes",
  "Beds",
  "TV Units",
  "Tables",
  "Dressing Tables",
  "Sofa Beds",
];

export const Marquee = () => (
  <div className="overflow-hidden border-y border-[#3A2A1F] bg-walnut py-4" aria-hidden="true">
    <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span
          key={i}
          className="flex items-center gap-10 font-mono text-xs uppercase tracking-[0.3em] text-brasslight/80"
        >
          {item}
          <span className="h-1.5 w-1.5 rotate-45 bg-brass inline-block" />
        </span>
      ))}
    </div>
  </div>
);
